// src/data/exercises/index.js
// Catalog of exercises is now served dynamically from the API database.
export const exercises = [];
